require('./bootstrap');

$(document).on('click', '.toggle-password', function() {
    let icon = $(this).children('.fa-regular');

    if (icon.hasClass('fa-eye')) {
        // Reveal the password and change the icon
        icon.parent().siblings('input').attr('type', 'text');
        icon.removeClass('fa-eye').addClass('fa-eye-slash');
    } else {
        // hide the password and change the icon
        icon.parent().siblings('input').attr('type', 'password');
        icon.addClass('fa-eye').removeClass('fa-eye-slash');
    }

});
